import { render, staticRenderFns } from "./OrderNonRelatedToSpkb.vue?vue&type=template&id=f1406de8&"
import script from "./OrderNonRelatedToSpkb.vue?vue&type=script&lang=js&"
export * from "./OrderNonRelatedToSpkb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports